import React from "react";
import styled from "styled-components/macro";
import { useMediaQuery } from "react-responsive";

import myTulu1 from "../../images/MyTulu/myTulu1.svg";
import smartMaintananceLogo from "../../images/MyTulu/myTulu2.svg";
import customizedAppLogo from "../../images/MyTulu/myTulu3.svg";
import liveDataLogo from "../../images/MyTulu/myTulu4.svg";
import marketingLogo from "../../images/MyTulu/myTulu5.png";
import myTulu6 from "../../images/MyTulu/myTulu6.svg";
import { device } from "../device";

import { proposal } from "../../globalState";
import { useSnapshot } from "valtio";

const Costs = ({
  ownerRevenue,
  isPDF,
  currencySymbol,
  numOfUnit,
  setupFee,
  setupFeeBeforeDiscount,
  serviceFee,
  serviceFeeBeforeDiscount,
  buildingName,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const snapshot = useSnapshot(proposal);
  const iconSize = isMobile ? "31px" : isPDF ? 75 : 50;

  const isStudential = proposal.proposal?.typeOfProperty?.includes("student");
  const toCurrency = (number) =>
    number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return (
    <Wrapper isPDF={isPDF}>
      <Title isPDF={isPDF} marginBottom={13}>
        Pricing Plans
      </Title>
      <BuildingNameWrapper isPDF={isPDF}>
        <BuildingTitle
          isPDF={isPDF}
          smallerOnMobile={22}
          style={{ color: "#000000" }}
        >
          {buildingName}
        </BuildingTitle>
        {numOfUnit && (
          <UnitSubTitle isPDF={isPDF}>{`${numOfUnit} ${
            isStudential ? "Beds" : "Units"
          }`}</UnitSubTitle>
        )}
      </BuildingNameWrapper>

      {setupFee && serviceFee && (
        <FeeWrapper isPDF={isPDF}>
          {!snapshot.hide12months && setupFee && (
            <Fee isPDF={isPDF}>
              <SubTittleContainer>
                <SubTitle
                  style={{
                    marginTop: 6,
                    marginBottom: isMobile ? 0 : 12,
                    fontSize: isPDF && 25,
                    letterSpacing: 1,
                  }}
                >
                  12 MONTHS
                </SubTitle>
                <SavingPercent
                  isPDF={isPDF}
                  style={{ color: "white", pointerEvents: "none" }}
                >
                  im a ghost
                </SavingPercent>
              </SubTittleContainer>
              {isMobile ? <span></span> : <Divider />}

              <Subscription isPDF={isPDF}>Subscription</Subscription>
              <FinalCostContainer>
                <MonthlyCost isPDF={isPDF}>
                  <CurrencySymbol isPDF={isPDF}>
                    {" "}
                    {currencySymbol}
                  </CurrencySymbol>
                  {toCurrency(serviceFee)}
                  <Mo isPDF={isPDF}>/mo</Mo>
                </MonthlyCost>
              </FinalCostContainer>
              <Divider />
              <BottomFee>
                <OneTimeSetupFee isPDF={isPDF}>
                  One-time setup fee
                </OneTimeSetupFee>

                <Flex>
                  {setupFeeBeforeDiscount ? (
                    <FeeTextWrapper>
                      <SubTitleBeforeDiscount isPDF={isPDF}>
                        {currencySymbol}
                      </SubTitleBeforeDiscount>
                      <TitleBeforeDiscount isPDF={isPDF}>
                        {toCurrency(setupFeeBeforeDiscount) || 100}
                      </TitleBeforeDiscount>
                    </FeeTextWrapper>
                  ) : (
                    <span></span>
                  )}
                  <FeeTextWrapper>
                    <SubTitleBeforeDiscount
                      style={{
                        color: "black",
                        top: isMobile ? -8 : isPDF ? -16 : -8,
                        fontSize: isMobile ? 9 : isPDF ? 18 : 12,
                        fontWeight: "bold",
                      }}
                    >
                      {currencySymbol}
                    </SubTitleBeforeDiscount>
                    <FinalCost isPDF={isPDF}>{toCurrency(setupFee)}</FinalCost>
                  </FeeTextWrapper>
                </Flex>
              </BottomFee>
            </Fee>
          )}

          {serviceFee && (
            <Fee isPDF={isPDF}>
              <SubTittleContainer>
                <SubTitle
                  style={{
                    marginBottom: isMobile ? 0 : 12,
                    fontSize: isPDF && 25,
                    letterSpacing: 1,
                  }}
                >
                  24 MONTHS
                </SubTitle>
                <SavingPercent isPDF={isPDF}>SAVE 10%</SavingPercent>
              </SubTittleContainer>
              {isMobile ? <span></span> : <Divider />}
              <Subscription isPDF={isPDF}>Subscription</Subscription>
              <FinalCostContainer>
                <MonthlyCost isPDF={isPDF}>
                  <CurrencySymbol isPDF={isPDF}>
                    {" "}
                    {currencySymbol}
                  </CurrencySymbol>
                  {toCurrency(Math.round(serviceFee * 0.9))}
                  <Mo isPDF={isPDF}>/mo</Mo>
                </MonthlyCost>
              </FinalCostContainer>
              <Divider />
              <BottomFee>
                <OneTimeSetupFee isPDF={isPDF}>
                  One-time setup fee
                </OneTimeSetupFee>
                <Flex>
                  {setupFeeBeforeDiscount ? (
                    <FeeTextWrapper>
                      <SubTitleBeforeDiscount isPDF={isPDF}>
                        {currencySymbol}
                      </SubTitleBeforeDiscount>
                      <TitleBeforeDiscount isPDF={isPDF}>
                        {toCurrency(setupFeeBeforeDiscount) || 100}
                      </TitleBeforeDiscount>
                    </FeeTextWrapper>
                  ) : (
                    <span></span>
                  )}
                  <FeeTextWrapper>
                    <SubTitleBeforeDiscount
                      style={{
                        color: "black",
                        top: isMobile ? -8 : isPDF ? -16 : -8,
                        fontSize: isMobile ? 9 : isPDF ? 18 : 12,
                        fontWeight: "bold",
                      }}
                    >
                      {currencySymbol}
                    </SubTitleBeforeDiscount>
                    <FinalCost isPDF={isPDF}>{toCurrency(setupFee)}</FinalCost>
                  </FeeTextWrapper>
                </Flex>
              </BottomFee>
            </Fee>
          )}
          {serviceFee && (
            <Fee isPDF={isPDF}>
              <SubTittleContainer>
                <SubTitle
                  style={{
                    marginBottom: isMobile ? 0 : 12,
                    fontSize: isPDF && 25,
                    letterSpacing: 1,
                  }}
                >
                  36 MONTHS
                </SubTitle>
                <SavingPercent isPDF={isPDF}>SAVE 20%</SavingPercent>
              </SubTittleContainer>
              {isMobile ? <span></span> : <Divider />}
              <Subscription isPDF={isPDF}>Subscription</Subscription>
              <FinalCostContainer>
                <MonthlyCost isPDF={isPDF}>
                  <CurrencySymbol isPDF={isPDF}>
                    {" "}
                    {currencySymbol}
                  </CurrencySymbol>
                  {toCurrency(Math.round(serviceFee * 0.8))}
                  <Mo isPDF={isPDF}>/mo</Mo>
                </MonthlyCost>
              </FinalCostContainer>
              <Divider />
              <BottomFee>
                <OneTimeSetupFee isPDF={isPDF}>
                  One-time setup fee
                </OneTimeSetupFee>
                <Flex>
                  {setupFeeBeforeDiscount ? (
                    <FeeTextWrapper>
                      <SubTitleBeforeDiscount isPDF={isPDF}>
                        {currencySymbol}
                      </SubTitleBeforeDiscount>
                      <TitleBeforeDiscount isPDF={isPDF}>
                        {toCurrency(setupFeeBeforeDiscount) || 100}
                      </TitleBeforeDiscount>
                    </FeeTextWrapper>
                  ) : (
                    <span></span>
                  )}

                  <FeeTextWrapper>
                    <SubTitleBeforeDiscount
                      style={{
                        color: "black",
                        top: isMobile ? -8 : isPDF ? -16 : -8,
                        fontSize: isMobile ? 9 : isPDF ? 18 : 12,
                        fontWeight: "bold",
                      }}
                    >
                      {currencySymbol}
                    </SubTitleBeforeDiscount>
                    <FinalCost isPDF={isPDF} style={{ position: "relative" }}>
                      {toCurrency(setupFee)}
                    </FinalCost>
                  </FeeTextWrapper>
                </Flex>
              </BottomFee>
              {!isMobile && (
                <SubTitle
                  style={{
                    width: "100%",
                    position: "relative",
                    left: isPDF ? -900 : 125,
                    top: isPDF ? 190 : 140,
                    fontSize: isPDF ? 25 : 15,
                    fontWeight: isPDF && "normal",
                  }}
                >
                  All plans are paid upfront.
                </SubTitle>
              )}
            </Fee>
          )}
        </FeeWrapper>
      )}

      {isMobile && (
        <SubTitle
          style={{
            width: "100%",
            fontsize: "15px",
            marginTop: 20,
            textAlign: "center",
            fontSize: "10px",
            fontWeight: "normal",
          }}
        >
          All plans are paid upfront.
        </SubTitle>
      )}

      <OwnerReceives
        isPDF={isPDF}
        style={{
          marginLeft: isPDF && 0,
          marginTop: !isMobile && 90,
          borderBottom: isMobile ? "6px #214d5c solid" : "10px #214d5c solid",
        }}
      >
        Owner Receives {ownerRevenue || 50}% of All Usage Revenue!
      </OwnerReceives>
      <Flex style={{ marginTop: isMobile && 24 }}>
        <TilesWrapper isPDF={isPDF}>
          <TileWrapper isPDF={isPDF}>
            <img
              width={iconSize}
              height={iconSize}
              style={{ marginRight: "12px", objectFit: "contain" }}
              src={myTulu1}
              alt={"myTulu1"}
            />
            <IconText>24/7 customer support</IconText>
          </TileWrapper>
          <TileWrapper isPDF={isPDF}>
            <img
              width={iconSize}
              height={iconSize}
              style={{ marginRight: "12px", objectFit: "contain" }}
              src={smartMaintananceLogo}
              alt={"smartMaintananceLogo"}
            />
            <IconText>Smart maintenance system</IconText>
          </TileWrapper>
          <TileWrapper isPDF={isPDF}>
            <img
              alt="customized App"
              width={iconSize}
              height={iconSize}
              style={{ marginRight: "12px", objectFit: "contain" }}
              src={customizedAppLogo}
            />
            <IconText>Customized app</IconText>
          </TileWrapper>
        </TilesWrapper>
        <TilesWrapper style={isPDF && iconsStyle}>
          <TileWrapper isPDF={isPDF}>
            <img
              width={iconSize}
              height={iconSize}
              style={{ marginRight: isPDF ? 12 : 14, objectFit: "contain" }}
              src={liveDataLogo}
              alt={"liveDataLogo"}
            />
            <IconText>Live data dashboard</IconText>
          </TileWrapper>
          <TileWrapper
            isPDF={isPDF}
            style={{ padding: isMobile && "4px 0px 4px 14px" }}
          >
            <img
              width={iconSize}
              height={iconSize}
              style={{
                width: isPDF && 64,
                height: isPDF && 69,
                marginRight: isPDF ? 23 : 15,
                objectFit: "contain",
              }}
              src={marketingLogo}
              alt="marketing logo"
            />
            <IconText>Marketing collateral & events</IconText>
          </TileWrapper>
          <TileWrapper isPDF={isPDF}>
            <img
              width={iconSize}
              height={iconSize}
              style={{
                marginRight: 14,
                objectFit: "contain",
              }}
              src={myTulu6}
              alt={"myTulu6"}
            />
            <IconText>Liability insurance</IconText>
          </TileWrapper>
        </TilesWrapper>
      </Flex>
    </Wrapper>
  );
};

export { Costs };

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "DMSans", serif;
  padding: ${({ isPDF }) => isPDF && "0px 97px"};

  @media ${device.tablet} {
    padding: 50px;
  }

  @media ${device.laptopM} {
    padding: ${({ isPDF }) => (isPDF ? "0px 97px" : "100px")};
  }
`;

const Title = styled.span`
  font-weight: bold;
  margin-top: ${({ isPDF }) => !isPDF && "28px"};
  text-align: ${({ isPDF }) => (isPDF ? "left" : "center")};
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  font-family: "lexend", serif;

  @media ${device.mobileS} {
    font-size: ${({ smallerOnMobile }) => smallerOnMobile || 25}px;
  }
  @media ${device.tablet} {
    text-transform: inherit;
    font-size: 50px;
  }
`;

const BuildingTitle = styled.span`
  font-family: "Lexend", serif;
  font-weight: bold;
  margin-bottom: 4px;
  text-align: ${({ isPDF }) => (isPDF ? "left" : "center")};
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  @media ${device.mobileS} {
    font-size: ${({ smallerOnMobile }) => smallerOnMobile || 31}px;
  }
  @media ${device.tablet} {
    font-size: ${({ isPDF }) => (isPDF ? 40 : 31)}px;
  }
`;

const SubTitle = styled.span`
  font-family: "DMSans", serif;
  width: 172px;
  height: 45px;
  //margin: 0 132.4px 5.5px 0.4px;
  margin-top: 20px;
  font-family: DMSans;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  @media ${device.mobileS} {
    height: auto;
    margin-bottom: 18px;
    margin-top: 2px;
    font-size: 15px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;

const UnitSubTitle = styled(SubTitle)`
  text-align: ${({ isPDF }) => (isPDF ? "start" : "center")};
  font-weight: normal;

  @media ${device.mobileS} {
    font-size: 15px;
  }
  @media ${device.tablet} {
    font-size: ${({ isPDF }) => (isPDF ? 31 : 20)}px;
  }
`;

const TitleBeforeDiscount = styled.span`
  text-transform: uppercase;
  text-decoration: line-through;
  font-weight: lighter;
  font-family: "DMSans", serif;
  color: #acaaa3;
  font-size: 10px;

  @media ${device.tablet} {
    line-height: -4.2;
    font-size: ${({ isPDF }) => (isPDF ? 22 : 13)}px;
  }
`;

const SubTitleBeforeDiscount = styled.div`
  position: relative;
  top: -4px;
  left: -1px;
  font-family: "DMSans", serif;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  color: #acaaa3;
  height: min-content;
  font-size: ${({ isPDF }) => (isPDF ? 14 : 8)}px;

  @media ${device.tablet} {
    top: ${({ isPDF }) => (isPDF ? -10 : -5)}px;
    left: ${({ isPDF }) => (isPDF ? -2 : -1)}px;
  }
`;

const FinalCost = styled(SubTitle)`
  font-family: "Lexend", serif;
  width: fit-content;
  height: min-content;
  font-weight: bold;
  padding: 0;
  margin: 0;
  font-size: 18px;
  margin-bottom: 0px;

  @media ${device.tablet} {
    font-size: ${({ isPDF }) => (isPDF ? 35 : 22)}px;
    margin-bottom: 0px;
  }
`;

const MonthlyCost = styled(FinalCost)`
  display: flex;
  font-size: ${({ isPDF }) => (isPDF ? 60 : 32)}px;
`;

const FeeWrapper = styled.div`
  display: flex;
  width: 100%;
  //position: relative;
  flex-direction: column;
  justify-content: center;
  margin-top: -30px;
  align-items: center;
  //margin-right: 119.5px;
  margin: auto;
  @media ${device.tablet} {
    margin: ${({ isPDF }) => (isPDF ? "auto" : "auto")};
    justify-content: ${({ isPDF }) => (isPDF ? "start" : "center")};

    flex-direction: row;
  }
`;

const Fee = styled.span`
  //height: 400px;
  //height: 171px;
  //margin: 19px 33.3px 31px 163.3px;
  //padding: 95.4px 62.6px 79.2px 65.8px;
  padding: 20px 36px;
  width: 88%;
  margin-top: 19px;
  border-radius: 14px;
  object-fit: contain;
  box-shadow: 0 6px 50px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;

  @media ${device.tablet} {
    min-width: 340px;
    max-width: ${({ isPDF }) => !isPDF && "400px"};

    width: ${({ isPDF }) => (isPDF ? "433px" : "22%")};
    height: ${({ isPDF }) => (isPDF ? "540px" : "430px")};
    padding: ${({ isPDF }) =>
      isPDF ? "95px 40px 8px 40px" : "90px 25px 8px 25px"};
    margin: 0px;

    margin-top: 30px;
    border-radius: 0px;
  }
`;

const BuildingNameWrapper = styled.span`
  display: flex;
  position: relative;
  gap: 7px;
  flex-direction: column;
  align-items: ${({ isPDF }) => (isPDF ? "start" : "center")};
  @media ${device.mobileS} {
    margin-left: 2px;
    margin-bottom: -3px;
  }
  @media ${device.tablet} {
    margin-top: -6px;
    margin-bottom: -3px;
    //margin-left: 84px;
  }
`;

const FeeTextWrapper = styled.div`
  display: flex;
  //position: relative;
  flex-direction: row;
  align-items: flex-end;
  margin: 0;
  padding: 0;
  height: 30px;

  @media ${device.mobileM} {
    height: auto;
  }

  @media ${device.tablet} {
    height: auto;
    margin-bottom: 4px;
  }
`;

const Divider = styled.div`
  height: 1px;
  border-top: 1px solid black;
  width: 100%;
  margin: auto;
`;

const Subscription = styled.h2`
  width: 255px;
  height: 16px;
  margin-top: -20px;
  margin: 0px 50px 10px 0px;
  font-family: DMSans;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  @media ${device.tablet} {
    height: auto;
    font-size: ${({ isPDF }) => (isPDF ? 25 : 15)}px;
    margin: 33.2px 49.8px 5.2px 0.4px;
  }
`;

const OneTimeSetupFee = styled.span`
  font-family: DMSans;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  //display: inline-block;
  color: #707070;
  @media ${device.tablet} {
    font-size: ${({ isPDF }) => (isPDF ? 25 : 15)}px;
    margin: ${({ isPDF }) =>
      isPDF ? "12px 0px 12px 0px" : "33.2px 49.8px 8px 0.4px"};
  }
`;

const SavingPercent = styled.p`
  margin-top: 2px;
  margin-bottom: 14px;
  letter-spacing: 1px;

  //margin: 0 7.6px 17.6px 40.6px;
  font-family: DMSans;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  text-align: left;
  color: #12637a;
  @media ${device.tablet} {
    margin-bottom: 4px;
    font-size: ${({ isPDF }) => (isPDF ? 25 : 20)}px;
    position: relative;
    top: -2px;

    text-align: right;
  }
`;

const Flex = styled.div`
  display: flex;
  gap: 6px;

  @media ${device.tablet} {
    flex-direction: column;
    gap: 0px;
  }
`;
const Mo = styled.span`
  width: 305px;
  font-family: Lexend;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.3;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;

  @media ${device.mobileM} {
    font-size: ${({ isPDF }) => isPDF && 30}px;
  }
`;

const OwnerReceives = styled.div`
  height: 34px;
  margin: 0 auto;
  object-fit: contain;
  font-family: DMSans;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  padding-bottom: 6px;

  @media ${device.mobileS} {
    height: auto;
    width: 152px;

    font-size: 15px;
  }
  @media ${device.tablet} {
    width: fit-content;
    margin-bottom: 36px;
    flex-direction: row;
    font-size: ${({ isPDF }) => (isPDF ? 31 : 20)}px;
  }
`;

const SubTittleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: right;
  @media ${device.tablet} {
    flex-direction: row;

    justify-content: space-between;
    align-items: center;
  }
`;

const FinalCostContainer = styled.div`
  margin-top: -12px;
  margin-bottom: 6px;
  @media ${device.tablet} {
    margin-top: 2px;

    margin-bottom: 17px;
  }
`;

const BottomFee = styled.div`
  //border: red 1px solid;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  height: 30px;

  @media ${device.mobileM} {
    margin-top: 26px;
  }
  @media ${device.tablet} {
    flex-direction: column;
  }
`;

const TilesWrapper = styled.div`
  margin-bottom: 12px;
  display: flex;

  position: relative;
  flex-direction: column;
  align-items: ;
  @media ${device.mobileS} {
    justify-content: space-around;
  }
  @media ${device.tablet} {
    column-gap: 2px;
    row-gap: 19px;
    justify-content: center;
    margin: auto;
    margin-top: 18px;
    position: ${({ isPDF }) => isPDF && "absolute"};
    max-width: ${({ isPDF }) => !isPDF && "1200px"};
    min-width: ${({ isPDF }) => !isPDF && "1000px"};
    flex-direction: ${({ isPDF }) => (isPDF ? "column" : "row")};
    top: ${({ isPDF }) => (isPDF ? "363px" : "45px")};
    right: ${({ isPDF }) => isPDF && "12px"};
    transform: ${({ isPDF }) =>
      isPDF && "scale(0.9) translateX(-50px) translateY(-27px);"};
    gap: ${({ isPDF }) => isPDF && 20}px;
    //padding-bottom: 107.9px;
  }
`;

const TileWrapper = styled.div`
  display: flex;
  /* position: relative; */
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  /* flex: 1; */
  @media ${device.mobileS} {
    padding: 4px 14px;
  }
  @media ${device.tablet} {
    width: ${({ isPDF }) => (isPDF ? "100%" : "360px")};
  }
`;

const IconText = styled.span`
  font-family: DMSans, serif;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0}px;
  @media ${device.mobileS} {
    font-size: 8px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;

const CurrencySymbol = styled.div`
  position: relative;
  top: ${({ isPDF }) => (isPDF ? 10 : 3)}px;
  font-size: ${({ isPDF }) => (isPDF ? 28 : 18)}px;
`;

const iconsStyle = {
  flexDirection: "column",
  top: -470,
  left: 1050,
  gap: 20,
  transform: `scale(0.9) translateX(-50px) translateY(-27px)`,
};
